export const mapping = {
    Andorra: "AND",
    "United Arab Emirates": "ARE",
    Afghanistan: "AFG",
    "Antigua and Barbuda": "ATG",
    Anguilla: "AIA",
    Albania: "ALB",
    Armenia: "ARM",
    "Netherlands Antilles": "ANT",
    Angola: "AGO",
    Antarctica: "ATA",
    Argentina: "ARG",
    Austria: "AUT",
    Australia: "AUS",
    Aruba: "ABW",
    Azerbaijan: "AZE",
    "Bosnia and Herzegovina": "BIH",
    Barbados: "BRB",
    Bangladesh: "BGD",
    Belgium: "BEL",
    "Burkina Faso": "BFA",
    Bulgaria: "BGR",
    Bahrain: "BHR",
    Burundi: "BDI",
    Benin: "BEN",
    Bermuda: "BMU",
    "Brunei Darussalam": "BRN",
    "Bolivia (Plurinational State of)": "BOL",
    Brazil: "BRA",
    Bahamas: "BHS",
    Bhutan: "BTN",
    "Bouvet Island": "BVT",
    Botswana: "BWA",
    Belarus: "BLR",
    Belize: "BLZ",
    "Congo, Democratic Republic of the": "COD",
    Congo: "COG",
    Canada: "CAN",
    "Cocos (Keeling) Islands": "CCK",
    "Central African Republic": "CAF",
    Chad: "TCD",
    Chile: "CHL",
    China: "CHN",
    Colombia: "COL",
    "Costa Rica": "CRI",
    Cuba: "CUB",
    "Cabo Verde": "CPV",
    "Cook Islands": "COK",
    Cyprus: "CYP",
    "Czech Republic": "CZE",
    Germany: "DEU",
    Djibouti: "DJI",
    Denmark: "DNK",
    "Dominica, Commonwealth of": "DMA",
    "Dominican Republic": "DOM",
    Algeria: "DZA",
    Ecuador: "ECU",
    "Egypt, Arab Republic of": "EGY",
    "Western Sahara": "ESH",
    Estonia: "EST",
    "El Salvador": "SLV",
    Eritrea: "ERI",
    "Spain, Spanish State": "ESP",
    Ethiopia: "ETH",
    Finland: "FIN",
    "Fiji the Fiji Islands": "FJI",
    "Falkland Islands (Malvinas)": "FLK",
    Micronesia: "FSM",
    "Faeroe Islands": "FRO",
    France: "FRA",
    Gabon: "GAB",
    "United Kingdom": "GBR",
    "Gambia the": "GMB",
    Guinea: "GIN",
    "Guinea-Bissau": "GNB",
    "Equatorial Guinea": "GNQ",
    Greece: "GRC",
    Greenland: "GRL",
    Guatemala: "GTM",
    Guam: "GUM",
    Guyana: "GUY",
    "Hong Kong, Special Administrative Region of China": "HKG",
    "Heard and McDonald Islands": "HMD",
    Honduras: "HND",
    Croatia: "HRV",
    Haiti: "HTI",
    Hungary: "HUN",
    Indonesia: "IDN",
    Ireland: "IRL",
    "Israel, State of": "ISR",
    India: "IND",
    Iran: "IRN",
    Iraq: "IRQ",
    Iceland: "ISL",
    Italy: "ITA",
    Jamaica: "JAM",
    Jordan: "JOR",
    Japan: "JPN",
    Kenya: "KEN",
    "Kyrgyz Republic": "KGZ",
    Cambodia: "KHM",
    Kiribati: "KIR",
    "North Korea": "PRK",
    "South Korea": "KOR",
    Kuwait: "KWT",
    Kazakhstan: "KAZ",
    Lao: "LAO",
    Lebanon: "LBN",
    "St. Lucia": "LCA",
    Liechtenstein: "LIE",
    "Sri Lanka": "LKA",
    Liberia: "LBR",
    Lesotho: "LSO",
    Lithuania: "LTU",
    Luxembourg: "LUX",
    Latvia: "LVA",
    "Libyan Arab Jamahiriya": "LBY",
    Morocco: "MAR",
    Monaco: "MCO",
    Moldova: "MDA",
    Madagascar: "MDG",
    "Marshall Islands": "MHL",
    Macedonia: "MKD",
    Mali: "MLI",
    Myanmar: "MMR",
    Mongolia: "MNG",
    Macao: "MAC",
    "Northern Mariana Islands": "MNP",
    Martinique: "MTQ",
    Mauritania: "MRT",
    Montserrat: "MSR",
    Malta: "MLT",
    Mauritius: "MUS",
    Maldives: "MDV",
    Malawi: "MWI",
    Mexico: "MEX",
    Malaysia: "MYS",
    Mozambique: "MOZ",
    Namibia: "NAM",
    "New Caledonia": "NCL",
    "Niger the": "NER",
    "Norfolk Island": "NFK",
    Nigeria: "NGA",
    Nicaragua: "NIC",
    "Netherlands the": "NLD",
    Norway: "NOR",
    Nepal: "NPL",
    Nauru: "NRU",
    Niue: "NIU",
    "New Zealand": "NZL",
    Oman: "OMN",
    Panama: "PAN",
    Peru: "PER",
    "French Polynesia": "PYF",
    "Papua New Guinea": "PNG",
    "Philippines the": "PHL",
    Pakistan: "PAK",
    Poland: "POL",
    "St. Pierre and Miquelon": "SPM",
    "Pitcairn Island": "PCN",
    "Puerto Rico": "PRI",
    "Palestinian Territory": "PSE",
    Portugal: "PRT",
    Qatar: "QAT",
    Réunion: "REU",
    Romania: "ROU",
    "Russian Federation": "RUS",
    Rwanda: "RWA",
    "Saudi Arabia": "SAU",
    "Solomon Islands": "SLB",
    Seychelles: "SYC",
    "Sudan the": "SDN",
    Sweden: "SWE",
    Singapore: "SGP",
    "South Georgia and the South Sandwich Islands": "SGS",
    Slovenia: "SVN",
    Svalbard: "SJM",
    Slovakia: "SVK",
    "Sierra Leone": "SLE",
    "San Marino": "SMR",
    Senegal: "SEN",
    "Somalia, Somali Republic": "SOM",
    Suriname: "SUR",
    "Sao Tome and Principe": "STP",
    "El Salvador": "SLV",
    Syria: "SYR",
    Swaziland: "SWZ",
    "Turks and Caicos Islands": "TCA",
    Chad: "TCD",
    Togo: "TGO",
    Thailand: "THA",
    Tajikistan: "TJK",
    Tokelau: "TKL",
    Turkmenistan: "TKM",
    "Timor-Leste": "TLS",
    Tonga: "TON",
    "Trinidad and Tobago": "TTO",
    Tunisia: "TUN",
    Turkey: "TUR",
    Tuvalu: "TUV",
    Taiwan: "TWN",
    Tanzania: "TZA",
    Ukraine: "UKR",
    Uganda: "UGA",
    "United States Minor Outlying Islands": "UMI",
    "United States": "USA",
    Uruguay: "URY",
    Uzbekistan: "UZB",
    "Holy See": "VAT",
    "St. Vincent and the Grenadines": "VCT",
    Venezuela: "VEN",
    "British Virgin Islands": "VGB",
    "US Virgin Islands": "VIR",
    Vietnam: "VNM",
    Vanuatu: "VUT",
    "Wallis and Futuna Islands": "WLF",
    Samoa: "WSM",
    Yemen: "YEM",
    Mayotte: "MYT",
    Yugoslavia: "YUG",
    "South Africa": "ZAF",
    Zambia: "ZMB",
    Zimbabwe: "ZWE",
  };